import { render, staticRenderFns } from "./PurchasesDeliveryViewDetails.vue?vue&type=template&id=4b91c05a"
import script from "./PurchasesDeliveryViewDetails.vue?vue&type=script&lang=js"
export * from "./PurchasesDeliveryViewDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports